import React, {} from 'react';

import { CheckListItemElement } from '../../3rd-party/check-list';
import BaseElement from '../base';

function CheckListItem(props) {

  function renderMain() {

    return <BaseElement {...props}>
      <CheckListItemElement {...props} />
    </BaseElement>;

  }

  return renderMain();

}

export default CheckListItem;